import { ReactNode } from 'react';
export default function DialogContent({children}: {children?:ReactNode;[key:string]:any}) {return <div>{children}</div>;}
